module.exports = __webpack_public_path__ + "img/ic_food_ricecake.13075586.png";